import { TAB_NAMES } from 'shared/constants/app-settings-tabs';


const prefix = '/widget/cb6480f3-768b-4737-ab8f-10fe2e4fa2ab/article/';


export const APP_SETTINGS = {
  [TAB_NAMES.MAIN]: '758dcf00-c1fd-49db-a765-20dc9e38dd83',
  [TAB_NAMES.CHANNEL]: 'd76eaf25-334a-4e3c-a126-69d7de75bfc3',
  [TAB_NAMES.LAYOUT]: '660b2a10-ff77-42ca-aa47-74bf895fef63',
  [TAB_NAMES.SETTINGS]: '5c6d9ef8-4e72-4654-9335-26a5aed788c7',
  [TAB_NAMES.DESIGN]: '5dbb9fa8-6b65-4c5d-804c-6363cb0454d0',
};

export const DASHBOARD = {
  LIBRARY: `${prefix}a9755854-f70e-4875-9114-1c4361e75b23`,
  CHANNELS: `${prefix}d76eaf25-334a-4e3c-a126-69d7de75bfc3`,
  STATS: `${prefix}3b8e4c51-916f-4e62-b678-c2875dc57312`,
  SETTINGS: `${prefix}d60e85d5-320e-4181-845b-66d3e7de87e1`,
  EMAIL_MARKETING: `${prefix}caa7bf38-3b47-4d02-810a-01c68e087a59`,
};

export const HELP_LINK_PREFIX = 'https://www.wix.com/support/html5';

export const GFPP = `${prefix}70c76129-820f-4cf3-ba75-c8eebb39f955`;



// WEBPACK FOOTER //
// ./src/shared/constants/help-articles.js